export default __webpack_public_path__ + "static/media/icon-main-menu-close.83fb481a.svg";